function TimeSaveIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h50v50H0z" />
      <path d="M25 48c7.344 0 14.245-3.487 18.549-9.422v6.454H48V30.936H33.904v4.451h6.454C34.57 43.844 23.07 46.07 14.613 40.285 6.157 34.497 3.931 22.997 9.715 14.541 15.503 6.084 27.003 3.858 35.46 9.643c5.046 3.41 8.088 9.198 8.088 15.357v.742H48V25C48 12.311 37.69 2 25 2S2 12.311 2 25s10.311 23 23 23z" />
      <path d="M22.032 27.82l-5.935-5.936L12.981 25l7.496 7.495c.89.89 2.3.89 3.115 0l13.428-13.43-3.116-3.116-11.872 11.87z" />
    </svg>
  )
}

export default TimeSaveIcon
